import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import FilterSelectorView  from 'report/FilterSelectorView.js';


class ControlFilterSelectorFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.cornerRadius = '2';
        attributes.overridePrevious = false;
        attributes.respectDynamicFilter = false;
        attributes.type = 'dropdown';
        attributes.ignoreNull = 'false';
        attributes.hideEmptyFilter = 'false';
        attributes.Columns = { Column:  [{id:'0', Properties: {
            usesExpression: "false",
            formatoption: "",
            fieldId: "",
            width: "150",
            format: "none",
            caption: "",
            sortType: "none",
            visible: "true",
            setDynamicFilter: "false",
            align: "left",
            aggregation: "group",
            fieldDataType: "",
            sortOrder: "0"
        }}] };
		attributes.minWidth = 75;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);

        const view = new FilterSelectorView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlFilterSelectorFactory = new ControlFilterSelectorFactory();

export default controlFilterSelectorFactory;